import { Navigate, Route, Routes } from 'react-router-dom';
import BillingPage from './billing/BillingPage';
import CreateUserPage from './create/CreateUserPage';
import EditUserPage from './edit/EditUserPage';
import UserListPage from './list/UserListPage';

export default function UsersRouter() {
  return (
    <Routes>
      <Route element={<UserListPage />} index />
      <Route element={<CreateUserPage />} path="create" />
      <Route element={<BillingPage />} path="billing" />
      <Route element={<EditUserPage />} path=":userId" />
      <Route element={<Navigate to="" />} path="*" />
    </Routes>
  );
}
